import type { LeaderboardBoard, LeaderboardSeasonId } from './types';

export interface LeaderboardSeason {
  readonly id: LeaderboardSeasonId;
  readonly label: string;
  readonly active: boolean;
  readonly source: 'archive' | 'firebase';
}

export const LEADERBOARD_SEASONS: readonly LeaderboardSeason[] = Object.freeze([
  Object.freeze({ id: 'season3', label: 'Season 3', active: true, source: 'firebase' }),
  Object.freeze({ id: 'season2', label: 'Season 2', active: false, source: 'archive' }),
  Object.freeze({ id: 'season1', label: 'Season 1', active: false, source: 'archive' }),
]);

export const ACTIVE_LEADERBOARD_SEASON_ID: LeaderboardSeasonId = 'season3';
export const SEASON_1_ARCHIVE_PATH = '/assets/data/season1.json';
export const SEASON_2_ARCHIVE_PATH = '/assets/data/season2.json';

export function getLeaderboardSeason(id: LeaderboardSeasonId): LeaderboardSeason {
  const season = LEADERBOARD_SEASONS.find((candidate) => candidate.id === id);
  if (!season) throw new RangeError(`Unknown leaderboard season: ${id}`);
  return season;
}

export function boardLabel(board: LeaderboardBoard): string {
  return board === 'runs' ? 'Top 10 Runs' : 'Top 10 Freispiele';
}
